import { Component, Vue, Watch } from 'vue-property-decorator';
// import { SelectSection } from '../../services/selectedSection';
import * as T_T from 'cryface';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class NavSide extends Vue {
   public title: string = 'NavBarSide';
   public selected = '1';

   public configs = new CommonConfig();

   public test = '1';

   // nav path match section code
   public sections: string[] = [
      'showings',
      'listings',
      'reports',
      'dashboard',
      'predictions',
      'presales',
      'rifo/exlusives',
      '',
      'frontstore/setting',
      'listing-presentation/lists',
      'listing-presentation/stage',
   ];

   // force full path
   public mandatory: string[] = [
      'listing-presentation/lists',
      'listing-presentation/stage',
   ];

   public enabled: string[] = [];

   // public indexSelected() {
   //    return this.selectSectionService.Index.toString();
   // }

   public created() { }

   @Watch('$store.state.sideBar.selectedSection', { deep: true, immediate: true })
   public onSectionChanged(val: any, oldVal: any) {
      // alert(JSON.stringify(val));
      this.selected = val.section;
      const _refs: any = this.$refs;
      const intervalID = setInterval(() => {
         if (T_T.simpleDetect(_refs.navSide)) {
            _refs.navSide.currentActiveName = this.selected;
            _refs.navSide.updateActiveName();
            clearInterval(intervalID);
         }
      }, 200);
      // console.log(_refs.navSide);
   }

   public onSelect(value: number) {
      if (value - 8 === 0) {
         window.open(this.configs.dailyReportUrl);
      } else {
         if (this.mandatory.indexOf(this.sections[value - 1]) > -1) {
            this.$store.commit('selectSection', value);
            this.$router.push({ path: `/${this.sections[value - 1]}` });
         } else {
            // filter child router
            if (this.$route.fullPath.startsWith('/' + this.sections[value - 1].split('/')[0])) {
               this.$store.commit('selectSection', value);
            } else {
               this.$store.commit('selectSection', value);
               this.$router.push({ path: `/${this.sections[value - 1]}` });
            }
         }
      }
   }

   @Watch('$store.state.auth.menuList', { immediate: true, deep: true })
   public onMenuListGotten(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         val.map((v: any) => {
            this.enabled.push(
               v.x_name_en
            );
         });
      }
   }

}
